import { FC } from 'react';
import { SlotProps, SlotsType } from './types';

const Slot: FC<SlotProps> = ({ name, slot }) => {
    if (!name) {
        return <>{slot}</>;
    }

    if (!slot) return null;

    if (typeof slot === 'object' && name in slot) {
        return <>{(slot as SlotsType)[name]}</>;
    }

    return null;
};

export default Slot;
